import { AnalyticsPluginType } from '.';

declare global {
  interface Window {
    heap: any;
  }
}

class HeapPlugin implements AnalyticsPluginType {
  private initialized: boolean;
  constructor(heapAppId: string) {
    if (!window.heap) {
      console.error(
        'heap was not installed before attempting to initialize. It may be blocked by an ad/tracking blocker.',
      );
      this.initialized = false;
    } else {
      window.heap.load(heapAppId);
      this.initialized = true;
    }
  }

  identifyUser(
    userId: string,
    userProperties: Record<string, string | number>,
  ) {
    window.heap.identify(userId);
    window.heap.addUserProperties(userProperties);
  }

  isInitialized(): boolean {
    return this.initialized;
  }

  resetUser() {
    window.heap.resetIdentity();
  }

  trackEvent(category: string, action: string) {
    window.heap.track(`${category}-${action}`);
  }

  trackPageView(path: string) {
    window.heap.track('page_view', { path });
  }
}

export default HeapPlugin;
